module.exports = __webpack_public_path__ + "static/media/7.21796c4d.JPG";